import type { SVGProps } from "react";
// generated from LayoutRight.svg — do not edit manually
// prettier-ignore
export default function LayoutRight(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 15 4 H 21 V 20 H 15 M 15 4 H 3 V 20 H 15 M 15 4 V 20" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
